import CustomCard from '../../components/CustomCard/CustomCard'
import BackButton from '../../components/CustomButton/BackButton'
import { Flex, Row, Typography, Spin, Col } from 'antd'
import DealDetailNoSpace from "../../components/Details/DealDetailNoSpace"
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getTxnDetails } from '../../redux/slices/PaymentsSlice'
import { useParams } from 'react-router-dom'
import { capitalizeWords, formatCurrency } from '../../helpers/helpers'
import { formatPaymentDateTime } from './helpers'
import DealDetail from "../../components/Details/DealDetail"
import { GLOBAL_CONSTANTS } from '../../constants/constants'

const { Title, Text } = Typography

const TransactionSummaryContent = ({
    txnData,
    loading,
}) => (
    <Spin spinning={loading}>
        <Row align="middle">
            <Col xs={24} md={12}>
                <Flex align="center" justify='space-between' wrap>
                    <Title level={4}>Transaction Summary</Title>
                    <DealDetailNoSpace
                        label="Transaction Category"
                        value={<Text className='txn-cat'>{capitalizeWords(txnData?.transactionCategory)}</Text>}
                    />
                </Flex>
            </Col>
        </Row>
        <div className='details-container'>
            <Row gutter={[16, 16]}>
                <Col xs={24} md={12}>
                    <div className='detail-col-container'>
                        <DealDetail
                            label="Transaction ID"
                            value={txnData?.transactionId || GLOBAL_CONSTANTS.NA}
                        />
                        <DealDetail
                            label="UTR"
                            value={txnData?.utr || GLOBAL_CONSTANTS.NA}
                        />
                        <DealDetail
                            label="Particulars"
                            value={txnData?.particulars || GLOBAL_CONSTANTS.NA}
                        />
                        <DealDetail
                            label="Beneficiary Name"
                            value={txnData?.beneficiaryName || GLOBAL_CONSTANTS.NA}
                        />
                        <DealDetail
                            label="Beneficiary Account Number"
                            value={txnData?.beneficiaryAccNum || GLOBAL_CONSTANTS.NA}
                        />
                        <DealDetail
                            label="Remitter Name"
                            value={txnData?.remitterName || GLOBAL_CONSTANTS.NA}
                        />
                        <DealDetail
                            label="Remitter Account Number"
                            value={txnData?.remitterAccNum || GLOBAL_CONSTANTS.NA}
                        />
                    </div>
                </Col>
                <Col xs={24} md={12}>
                    <div className='detail-col-container'>
                        <DealDetail
                            label="Comments"
                            value={txnData?.comments || GLOBAL_CONSTANTS.NA}
                        />
                        <DealDetail
                            label="Transaction Status"
                            value={<Text className='txn-status'>{capitalizeWords(txnData?.transactionStatus)}</Text> || GLOBAL_CONSTANTS.NA}
                        />
                        <DealDetail
                            label="Transaction Date"
                            value={formatPaymentDateTime(txnData?.transactionDate) || GLOBAL_CONSTANTS.NA}
                        />
                        <DealDetail
                            label="Transaction Amount"
                            value={formatCurrency(txnData?.transactionAmount) || GLOBAL_CONSTANTS.NA}
                        />
                        <DealDetail
                            label="Performed By"
                            value={(() => {
                                const { userName, userId, email } = txnData?.requestedBy || {};
                                const who = userName || userId;
                                if (!who) return GLOBAL_CONSTANTS.NA;
                                return email ? `${who} (${email})` : who;
                            })()}
                        />
                        <DealDetail
                            label="Role"
                            value={txnData?.requestedBy?.userRole || GLOBAL_CONSTANTS.NA}
                        />
                    </div>
                </Col>
            </Row>
        </div>
    </Spin>
)

const PaymentDetails = () => {
    const dispatch = useDispatch()
    const { txnId } = useParams();
    const { txnData, loading } = useSelector((state) => state.payments);

    useEffect(() => {
        dispatch(getTxnDetails(txnId));
    }, [txnId, dispatch]);

    return (
        <div className='payment-details-container'>
            <BackButton />
            <CustomCard className='payment-details-card'>
                <TransactionSummaryContent
                    txnData={txnData}
                    loading={loading}
                />
            </CustomCard>
        </div>
    )
}

export default PaymentDetails
